import React, { useContext, type JSX } from 'react';
import {
  EKKontobegrepp_All as IData,
  EKKontobegrepp_AllVariables as IVariables,
} from './_QueryTypes/EKKontobegrepp_All';
import query from './EkonomiskAnalysKontobegreppQuery.gql';
import { IUIUrval } from '../../../../../../../Types/UrvalTypes';
import { getAttributeNames } from '../../../../../../../Components/Urval/Utils/urvalUtils';
import { IKontodel } from '../EkonomiskAnalysKontodelarQuery/EkonomiskAnalysKontodelarQuery';
import { EkonomiskAnalysContext } from '../../Components/Context/EkonomiskAnalysContext';
import { KodplanContext } from '../../../../../../../Components/KodplanManager/Context/KodplanContext';
import useHandledQuery from '../../../../../../../Components/QueryComponents/HandledQuery/HandledQueryHook';

interface IProps {
  loadingComponent?: JSX.Element | null;
  urval: IUIUrval | null;
  children: (result: IKontoValues[]) => React.ReactElement<any>;
}

export interface IKontoValues {
  name: string;
  values: IKontodel;
}

interface IBegreppValue {
  attributeName: string;
  ordningsnr: number;
  from: number;
  to: number;
}

const EkonomiskAnalysKontobegreppQuery: React.FC<IProps> = props => {
  const getKontobegreppValues = (data: IData): IKontoValues[] => {
    let kontoValues: IKontoValues[] = [];
    if (props.urval && data.db && data.db.EKKontobegrepp_All) {
      const a = getAttributeNames(props.urval.pages[0].conditionObjects);
      const urvalBegrepp = a.filter(x => x.match(/^KONTOBEGREPP_/));
      const begreppValues: IBegreppValue[] = urvalBegrepp.map(x => {
        const splitValues = x.split('_');
        return {
          attributeName: x,
          ordningsnr: parseInt(splitValues[1], 10),
          from: parseInt(splitValues[2], 10),
          to: parseInt(splitValues[3], 10),
        };
      });
      for (let i = 0; i < begreppValues.length; i++) {
        const begreppValue = data.db.EKKontobegrepp_All.find(
          x =>
            x.ORDNINGS_NR === begreppValues[i].ordningsnr &&
            x.FRAN_POSITION === begreppValues[i].from &&
            x.TILL_POSITION === begreppValues[i].to
        );
        if (
          begreppValue &&
          begreppValue._Associations &&
          begreppValue._Associations.Kontobegreppdef &&
          begreppValue._Associations.Kontobegreppdef._Associations
          // &&
          // begreppValue._Associations.Kontobegreppdef._Associations.Kontobegrepp
        ) {
          // begreppValue._Associations.Kontobegreppdef._Associations.Kontobegrepp
          const kontoBegrepp: IKontodel = {
            codeLength:
              begreppValue.TILL_POSITION - begreppValue.FRAN_POSITION + 1,
            kontodelar: data.db.EKKontobegrepp_All.filter(
              beg =>
                beg._Associations?.Kontobegreppdef?.id ===
                begreppValue._Associations?.Kontobegreppdef?.id
            ).map(x => ({
              name: `${x.KONTOBEGREPP} ${x.BENAMNING}`,
              id: x.KONTOBEGREPP,
            })),
          };

          kontoValues.push({
            name: begreppValues[i].attributeName,
            values: kontoBegrepp,
          });
        }
      }
    }

    return kontoValues;
  };

  const kodplanContext = useContext(KodplanContext);
  const { dbName } = useContext(EkonomiskAnalysContext);

  const queryResult = useHandledQuery<IData, IVariables>(
    query,
    {
      variables: {
        dbName,
        kodplanId: kodplanContext.activeKodplan
          ? kodplanContext.activeKodplan.id
          : '',
      },
      skip: kodplanContext.activeKodplan == null,
    },
    {
      loadingComponent: props.loadingComponent ? props.loadingComponent : null,
    }
  );

  if (!queryResult.data) {
    return props.children([]);
  }

  return props.children(getKontobegreppValues(queryResult.data));
};

export default EkonomiskAnalysKontobegreppQuery;
